import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue'; 
import TypeSelection from '@/views/TypeSelection.vue';
import SlotSelection from '@/views/SlotSelection.vue';
import UserInformation from '@/views/UserInformation.vue';
import Confirmation from '@/views/Confirmation.vue';
import Payment from '@/views/Payment.vue';
import ReservationFinal from '@/views/ReservationFinal.vue';
import Lookup from '@/views/Lookup.vue';
import Modification from '@/views/Modification.vue';
import NotFound from '@/views/NotFound.vue';
import alertUtil from '@/utils/alerts';
import store from '../store';
import PAGES from '../router/_pages';
import VerifyReservation from '../components/reservation/modification/VerifyReservation.vue';
import TypeOptions from '../views/TypeOptions.vue';

const routes = [
  {
    path: '/',
    alias: '/home',
    name: PAGES.home,
    component: Home
  },
  {
    path: '/type',
    name: PAGES.selectType,
    component: TypeSelection
  },
  {
    path: '/slot',
    name: PAGES.selectSlot,
    component: SlotSelection
  },
  {
    path: '/user',
    name: PAGES.userInfo,
    component: UserInformation
  },
  {
    path: '/pay',
    name: PAGES.payment,
    component: Payment
  },
  {
    path: '/confirm',
    name: PAGES.confirmRes,
    component: Confirmation
  },
  {
    path: '/reserved',
    name: PAGES.doneRes,
    component: ReservationFinal
  },
  {
    path: '/lookup',
    name: PAGES.findRes,
    component: Lookup
  },
  {
    path: '/verifyreservation',
    name: PAGES.verifyRes,
    component: VerifyReservation
  },
  {
    path: '/modify',
    name: PAGES.updateRes,
    component: Modification
  },
  {
    path: '/404',
    name: PAGES.pageNotFound,
    component: NotFound
  },
  {
    path: '/type/options',
    name: PAGES.selectTypeOptions,
    component: TypeOptions
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  routes
});

router.beforeEach(async (to, from) => {
  const isNotExpired = to.query.expired !== 'true';

  // Handle 404
  if (!to.matched.length) {
    console.warn('[Route Guard] Not found:', to);
    return { name: PAGES.pageNotFound };
  }

  // Handle skipnav
  if (to.hash === '#mainContent') {
    return true;  // Proceed with navigation
  }

  // Handle general "navigate away" modal
  const isNavigateAwayNeeded = (() => {
    const fromUserInfo = from.name === PAGES.userInfo && to.name !== PAGES.confirmRes
    && !(to.name === PAGES.updateRes && to.query?.from === 'newres');
    const fromPayment = from.name === PAGES.payment && to.name !== PAGES.userInfo;
    const fromConfirmationRes = from.name === PAGES.confirmRes && to.name !== PAGES.userInfo;
    const fromDoneRes = from.name === PAGES.confirmRes && to.name !== PAGES.doneRes;

    return fromUserInfo || (fromPayment && fromConfirmationRes && fromDoneRes);
  })();

  if (isNavigateAwayNeeded && isNotExpired) {
    const shouldProceed = await alertUtil.showNavigateAwayModal();
    if (!shouldProceed) return false;   // User canceled, cancel navigation
  }

  // Handle MFA-specific "navigate away" modal
  const isMfaNavigateAway =
    from.name === PAGES.confirmRes &&
    to.name === PAGES.userInfo &&
    isNotExpired;
  const isMfaNavigateAwayFromModify =
    from.name === PAGES.updateRes &&
    to.name === PAGES.userInfo &&
    isNotExpired;


  if (isMfaNavigateAway || (isMfaNavigateAwayFromModify )) {
    const needMfaModal = !store.state.user.customerDetail && window.config.USEMFA;
    if (needMfaModal) {
      const shouldProceed = await alertUtil.showNavigateAwayModalMfa();
      if (!shouldProceed) return false;   // User canceled, cancel navigation
    }
  }

  // Handle all other cases and proceed
  validateBrowser();
  transitionNetworkStatus();
  return true;
});

export default router;

function transitionNetworkStatus() {
  const networkResponse = store.state.user.networkResponse;
  
  if (networkResponse?.status) {
    const current = networkResponse.status;
    const statuses = store.state.user.STATUSES; 
    
    if (current !== statuses.SUCCESS && current !== statuses.SERVER_ERR) {
      // update network status to an intermediate state until the next network call
      store.dispatch('user/setTransitionalNetworkStatus'); 
    }
  }
}

function validateBrowser() {
  const ua = window.navigator.userAgent;
  // any IE, including non-Chrome Edge
  const isIE = /Edge\/|Trident\/|MSIE/.test(ua);
  if (isIE) {
    window.location.replace('noie.html');
  }
}